exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-educativo-tsx": () => import("./../../../src/pages/educativo.tsx" /* webpackChunkName: "component---src-pages-educativo-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-sobre-tsx": () => import("./../../../src/pages/sobre.tsx" /* webpackChunkName: "component---src-pages-sobre-tsx" */),
  "component---src-pages-social-tsx": () => import("./../../../src/pages/social.tsx" /* webpackChunkName: "component---src-pages-social-tsx" */)
}

